import styles from './style.module.scss';

interface Props {
    checked: boolean;
    setChecked: (checked: boolean) => void;
    text?: string;
    disabled?: boolean;
    className?: string;
    radioClassName?: string;
};

function RadioButton(props: Props) {
    const {
        checked,
        radioClassName,
        className,
        disabled,
        setChecked,
        text,
    } = props;

    const click = () => {
        if (disabled) return;
        setChecked(!checked);
    };

    return (
        <div className={styles.wrapper} onClick={click}>
            <div
                className={`${styles.radio} ${radioClassName || ''}`}
                data-radio-checked={checked}
            >
                <span className={styles.radio_disk}></span>
            </div>
            {text && (<span className={styles.text}>{text}</span>)}
        </div>
    );
};

export default RadioButton;
